export const forgottenPass = {
  title: 'Mot de passe oublié ?',
  email: {
    label: 'Email *',
    error: 'Merci de saisir un email valide.',
  },
  formsErrors: 'Erreurs dans le formulaire',
  desc: "Un mail contenant un nouveau mot de passe, d'une durée de vie de {tempPassDuration} minutes, vous sera envoyé à cette adresse.",
  btn: {
    ok: {
      label: 'Valider',
      loadingLabel: 'Envoi...',
      title: 'Valider le formulaire de mot de passe oublié',
    },
    cancel: {
      label: 'Annuler',
      title: 'Retourner au formulaire de connexion',
    },
  },
  msg: {
    error01:
      "Format de mail non valide.<br>Nombre d'essais restants : {rateLimitRemaining}<br>Renouvellement le {rateLimitReset}",
    error02:
      "Adresse mail inconnue.<br>Nombre d'essais restants : {rateLimitRemaining}<br>Renouvellement le {rateLimitReset}",
    error03Validating:
      "Compte en cours de validation.<br>Nombre d'essais restants : {rateLimitRemaining}<br>Renouvellement le {rateLimitReset}",
    error03Inactive:
      "Compte désactivé.<br>Nombre d'essais restants : {rateLimitRemaining}<br>Renouvellement le {rateLimitReset}",
    error03Refused:
      "Demande de création de compte refusée.<br>Nombre d'essais restants : {rateLimitRemaining}<br>Renouvellement le {rateLimitReset}",
    error04: 'Erreur technique lors de la récupération du mot de passe.',
    error05: "Erreur technique lors de l'envoi du mot de passe.",
    error_rate_limit:
      "Le nombre d'essais autorisés est atteint. Veuillez réitérer le {rateLimitReset}.",
    success: 'Si cet email existe, un mot de passe temporaire (validité de {tempPassDuration} minutes) y sera envoyé.',
  },
};
